import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FileText } from 'lucide-react';

const AffiliateBanner = ({ affiliateStatus, onDismiss }) => {
  const navigate = useNavigate();

  if (affiliateStatus !== 'pending_agreement') {
    return null;
  }

  return (
    <div className="mb-8 p-6 bg-gradient-to-r from-purple-50 to-blue-50 border-2 border-purple-300 rounded-xl shadow-lg animate-pulse">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
          <FileText className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-purple-900 mb-2">
            Action Required: Sign Affiliate Partner Agreement
          </h3>
          <p className="text-purple-800 mb-4">
            {`Congratulations! Your affiliate application has been approved. To complete your registration and start earning commissions, you must review and sign the Affiliate Partner Agreement.`}
          </p>
          <div className="flex gap-3">
            <Button
              onClick={() => navigate('/affiliate-agreement')}
              className="bg-gradient-to-r from-purple-500 to-blue-600 hover:from-purple-600 hover:to-blue-700 text-white"
            >
              <FileText className="w-4 h-4 mr-2" />
              Review & Sign Agreement
            </Button>
            <Button
              variant="outline"
              onClick={onDismiss}
              className="border-purple-300 text-purple-700 hover:bg-purple-50"
            >
              Remind Me Later
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliateBanner;
